module.exports = __webpack_public_path__ + "./images/tournament-prizes-icon.fe610d155dad2d767baded83ae9e0d9a.png";